/* src/app/shared/components/year-filter/year-filter.component.scss */
.tv-ns-primary-large-button-on-light-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  font: 700 13px FranceTV Brown;
  background-color: #F03C64;
  border: 1px solid #F03C64;
  color: #FFF;
}
.tv-ns-primary-large-button-on-light-bg:hover {
  background-color: #CC3456;
  border: 1px solid #CC3456;
}
.tv-ns-primary-large-button-on-light-bg:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-primary-large-button-on-dark-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  font: 700 13px FranceTV Brown;
  border: 1px solid #F03C64;
  background-color: #F03C64;
  color: #FFF;
}
.tv-ns-primary-large-button-on-dark-bg:hover {
  border: 1px solid #F03C64;
  background-color: transparent;
}
.tv-ns-primary-large-button-on-dark-bg:disabled {
  border: 1px solid #244666;
  background-color: rgba(223, 235, 247, 0.1);
  color: #6B90B3;
}
.tv-ns-secondary-large-button-on-light-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  font: 700 13px FranceTV Brown;
  background-color: #FFF;
  color: #244666;
  border: 1px solid #244666;
}
.tv-ns-secondary-large-button-on-light-bg:hover {
  background-color: #244666;
  border: 1px solid #244666;
  color: #FFF;
}
.tv-ns-secondary-large-button-on-light-bg:hover svg path {
  fill: #FFF !important;
}
.tv-ns-secondary-large-button-on-light-bg:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-secondary-large-button-dark-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  font: 700 13px FranceTV Brown;
  background-color: transparent;
  color: #DFEBF7;
  border: 1px solid #DFEBF7;
}
.tv-ns-secondary-large-button-dark-bg:hover {
  border: 1px solid #DFEBF7;
  background-color: #DFEBF7;
  color: #244666;
}
.tv-ns-secondary-large-button-dark-bg:disabled {
  border: 1px solid #244666;
  background-color: rgba(223, 235, 247, 0.1);
  color: #6B90B3;
}
.tv-ns-validation-large-button {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  font: 700 13px FranceTV Brown;
  background-color: #00D78C;
  border: 1px solid #00D78C;
  color: #FFF;
}
.tv-ns-validation-large-button:hover {
  background-color: #26C18B;
  border: 1px solid #26C18B;
}
.tv-ns-validation-large-button:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-validation-small-button {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 2px 8px;
  font: 400 10px FranceTV Brown;
  background-color: #00D78C;
  border: 1px solid #00D78C;
  color: #FFF;
}
.tv-ns-validation-small-button mat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 3px;
  padding-top: 1px;
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.tv-ns-validation-small-button:hover {
  background-color: #26C18B;
  border: 1px solid #26C18B;
}
.tv-ns-validation-small-button:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-small-blue-button {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 2px 8px;
  font: 400 10px FranceTV Brown;
  background-color: #0083FF;
  border: 1px solid #0083FF;
  color: #FFF;
}
.tv-ns-small-blue-button mat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 3px;
  padding-top: 1px;
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.tv-ns-small-blue-button:hover {
  background-color: #FFF;
  border: 1px solid #0083FF;
  color: #0083FF;
}
.tv-ns-small-blue-button:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-primary-large-button-on-light-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  font: 700 13px FranceTV Brown;
  background-color: #F03C64;
  border: 1px solid #F03C64;
  color: #FFF;
}
.tv-ns-primary-large-button-on-light-bg:hover {
  background-color: #CC3456;
  border: 1px solid #CC3456;
}
.tv-ns-primary-large-button-on-light-bg:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-primary-large-button-on-dark-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  font: 700 13px FranceTV Brown;
  border: 1px solid #F03C64;
  background-color: #F03C64;
  color: #FFF;
}
.tv-ns-primary-large-button-on-dark-bg:hover {
  border: 1px solid #F03C64;
  background-color: transparent;
}
.tv-ns-primary-large-button-on-dark-bg:disabled {
  border: 1px solid #244666;
  background-color: rgba(223, 235, 247, 0.1);
  color: #6B90B3;
}
.tv-ns-secondary-large-button-on-light-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  font: 700 13px FranceTV Brown;
  background-color: #FFF;
  color: #244666;
  border: 1px solid #244666;
}
.tv-ns-secondary-large-button-on-light-bg:hover {
  background-color: #244666;
  border: 1px solid #244666;
  color: #FFF;
}
.tv-ns-secondary-large-button-on-light-bg:hover svg path {
  fill: #FFF !important;
}
.tv-ns-secondary-large-button-on-light-bg:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-secondary-large-button-dark-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  font: 700 13px FranceTV Brown;
  background-color: transparent;
  color: #DFEBF7;
  border: 1px solid #DFEBF7;
}
.tv-ns-secondary-large-button-dark-bg:hover {
  border: 1px solid #DFEBF7;
  background-color: #DFEBF7;
  color: #244666;
}
.tv-ns-secondary-large-button-dark-bg:disabled {
  border: 1px solid #244666;
  background-color: rgba(223, 235, 247, 0.1);
  color: #6B90B3;
}
.tv-ns-validation-large-button {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  font: 700 13px FranceTV Brown;
  background-color: #00D78C;
  border: 1px solid #00D78C;
  color: #FFF;
}
.tv-ns-validation-large-button:hover {
  background-color: #26C18B;
  border: 1px solid #26C18B;
}
.tv-ns-validation-large-button:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-validation-small-button {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 2px 8px;
  font: 400 10px FranceTV Brown;
  background-color: #00D78C;
  border: 1px solid #00D78C;
  color: #FFF;
}
.tv-ns-validation-small-button mat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 3px;
  padding-top: 1px;
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.tv-ns-validation-small-button:hover {
  background-color: #26C18B;
  border: 1px solid #26C18B;
}
.tv-ns-validation-small-button:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-small-blue-button {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 2px 8px;
  font: 400 10px FranceTV Brown;
  background-color: #0083FF;
  border: 1px solid #0083FF;
  color: #FFF;
}
.tv-ns-small-blue-button mat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 3px;
  padding-top: 1px;
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.tv-ns-small-blue-button:hover {
  background-color: #FFF;
  border: 1px solid #0083FF;
  color: #0083FF;
}
.tv-ns-small-blue-button:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.date-range-picker-main-container {
  position: relative;
  display: inline-block;
}
/*# sourceMappingURL=year-filter.component.css.map */
